import React from "react"
import PropTypes from "prop-types"

import * as styles from "./item.module.scss"

const LocationItem = ({ eventLocation, boothNumber }) => {
  if (!eventLocation) return null

  return (
    <div className={styles.eventLocationWrapper}>
      <p>
        <b>Location: </b>
        {eventLocation}
      </p>
      <p>
        <b>Booth: </b>
        {boothNumber}
      </p>
    </div>
  )
}

export default LocationItem

LocationItem.propTypes = {
  eventLocation: PropTypes.string,
  boothNumber: PropTypes.number,
}
